import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { identity } from "lodash";
import { catchError, map, Observable, throwError, Subject, of } from "rxjs";
import { environment } from "src/environments/environment.prod";

export const ADMIN_MODULES = [
  { id: "dashboard", name: "Dashboard" },
  { id: "vendors", name: "Vendors" },
  { id: "trucks", name: "Trucks" },
  { id: "loads", name: "Loads" },
  { id: "drivers", name: "Drivers" },
  { id: "mapping", name: "Mapping" },
  { id: "driverOrders", name: "Driver Orders" },
  { id: "tax", name: "Tax" },
  { id: "pre_orders", name: "Pre Orders" },
  { id: "documents", name: "Documents" },
  { id: "trips", name: "Trips" },
  { id: "workorder", name: "Work Orders" },
  { id: "payments", name: "Payments" },
  { id: "reports", name: "Reports" },
  { id: "invoice", name: "Invoices" },
  { id: "track", name: "Track" },
  { id: "users", name: "Users" },
  { id: "settings", name: "Settings" },
  { id: "web", name: "Web Pages" },
  { id: "promotional_notifications", name: "Promotional Notifications" },
];

@Injectable({
  providedIn: "root",
})
export class AdminService {
  private refreshLRSubject = new Subject();
  private userPermissions: string[] | null = null;
  private isAdminUser: boolean = false;
  public toggleSidebar = new Subject<void>();

  constructor(private httpClient: HttpClient) { }

  setPermissions(permissions: string[], isAdmin: boolean) {
    this.userPermissions = permissions;
    this.isAdminUser = isAdmin;
  }

  getPermissions() {
    return this.userPermissions;
  }

  isAdmin() {
    return this.isAdminUser;
  }

  hasPermission(moduleId: string): boolean {
    if (this.isAdminUser) return true;
    return this.userPermissions ? this.userPermissions.includes(moduleId) : false;
  }

  GetLoadDetails(
    token: any,
    searchLoadType: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}load-details/admin?materialType=${searchLoadType}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  AddLoadDetails(loadData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}load-details/admin`,
        loadData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  DeleteLoadDetails(id: any, token: any, deleteLoadType: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}load-details/admin/${id}?materialName=${deleteLoadType}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  EditLoadDetails(loadData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}load-details/admin/${id}`,
        loadData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  adminLogin(loginData: any): Observable<any> {
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/login`,
        loginData,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  adminSendOtp(mobile: any): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/otpsend/${mobile}`
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  uploadImage(file: any): Observable<any> {
    var fd = new FormData();
    fd.append("upload", file);
    return this.httpClient
      .post(`${environment.base_url}${environment.base_uri}upload`, fd, {
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  profileUpdate(profileData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin`,
        profileData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  profileGet(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}admin`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  AddPassword(addPassObj: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin/update/password/${id}`,
        addPassObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAllVendors(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}admin-vendors`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => response),
        catchError(this.handleError)
      );
  }

  getVendorsByRegion(token: any, cluster: string): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}admin-vendors/${cluster}`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => response),
        catchError(this.handleError)
      );
  }

  AddTruckCatg(trucCatgObj: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truck-details/admin/category`,
        trucCatgObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTruckCatg(
    token: any,
    pageCount: any,
    truckCatgNumber: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details?page=${pageCount}&search_query=${truckCatgNumber}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTrucksCatg(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/tructype`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  truckCatgUpdate(updateTruckObj: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}truck-details/admin/category/${id}`,
        updateTruckObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTruckCtgy(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/admin/category/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetTruckType(
    token: any,
    truckTypeNumber: any,
    perPage: any,
    pageCount: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/admin/tructype?search_query=${truckTypeNumber}&perPage=${perPage}&page=${pageCount}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetTrucksType(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/admin/tructype?search_query=-1`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  AddTruckType(truckData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truck-details/admin/tructype`,
        truckData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetTrucksTypeAll(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/admin/tructype/all`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  deleteTruckCatg(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truck-details/category`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  AddTruck(truckObj: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trucks/admin`,
        truckObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  EditTruckType(truckData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}truck-details/admin/tructype/${id}`,
        truckData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  DeleteTruckType(truckData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truck-details/admin/tructype`,
        { headers: header, body: truckData, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetCategory(
    token?: any,
    truckTypeNumber?: any,
    perPage?: any,
    pageCount?: any,
    fetchAll?: boolean
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    let url = `${environment.base_url}${environment.base_uri}truck-details?search_query=${truckTypeNumber}&perPage=${perPage}&page=${pageCount}`;
    
    if (fetchAll) {
      url += `&fetch_all=true`;
    }

    return this.httpClient
      .get(url, { headers: header, observe: "response" })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  TrucksGet(
    token: any,
    pageCount: any,
    truckType: any,
    truckNumber: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/admin?truck_status=${truckType}&page=${pageCount}&search_query=${truckNumber}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  trucksGet(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/admin?search_query=-1&truck_status=-1`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetAvailableTrucks(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/admin/available`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  driversGet(
    token: any,
    pageCount: any,
    selectedDriverType: any,
    driverNumber: any,
    order: 'asc' | 'desc' = 'desc'
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}drivers/admin/list?driver_status=${selectedDriverType}&page=${pageCount}&search_query=${driverNumber}&order=${order}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetDriversList(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}drivers/admin`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetAvailableDrivers(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}drivers/admin/available`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addNotes(notesObj: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}notes/admin`,
        notesObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  DeleteTruck(truckDeleteId: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(`${environment.base_url}${environment.base_uri}trucks/admin`, {
        headers: header,
        body: truckDeleteId,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  DeleteTruckCateg(trucCatgkDeleteId: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truck-details/admin/category`,
        { headers: header, body: trucCatgkDeleteId, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetMappingsList(token: any, searchTruckNumber: any, perPage: any, page: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-mapping?truckNo=${searchTruckNumber}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetMasterList(token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}admin/masterData`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  AddMappings(token: any, data: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin-mapping`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  DeleteMappings(token: any, id: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}admin-mapping/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyDrivingLicense(dlNumber: string, dob: string, token: string): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    const body = {
      dlNumber: dlNumber,
      dob: dob,
    };
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/dl`,
        body,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyVehicleRC(rcNumber: string, token: string): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    const body = {
      rcNumber: rcNumber.trim().toUpperCase(),
    };
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/rc`,
        body,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyGST(gstin: string, token: string): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    const body = {
      gstin: (gstin || "").trim().toUpperCase(),
    };
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/gst`,
        body,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyPAN(pan: string, token: string): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    const body = {
      pan: (pan || "").trim().toUpperCase(),
    };
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/pan`,
        body,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  AddDriver(driverData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}drivers/admin/register/${id}`,
        driverData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // check 2 correct one 
  EditDriver(driverData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}drivers/admin/update/${id}`,
        driverData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateWorkorder(
    driverData: any,
    token: any,
    workorder_id: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin-workorder/update/${workorder_id}`,
        driverData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  tripEditTrip(tripsObj: any, token: any, trip_id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trips/update/${trip_id}`,
        tripsObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  retailEditTrips(tripsObj: any, token: any, trip_id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trips/update/retail/${trip_id}`,
        tripsObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  DeleteTruckCatg(token: any, trucCatgkDeleteId: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truck-details/admin/category`,
        { headers: header, body: trucCatgkDeleteId, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  TaxGet(
    token: any,
    userType: any,
    userName: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}taxes/admin?taxUserType=${userType}&taxName=${userName}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  taxAdd(taxObj: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}taxes/admin`,
        taxObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  sendLRRefreshData(value: number) {
    this.refreshLRSubject.next({ text: value });
  }

  getLRRefreshData(): Observable<any> {
    return this.refreshLRSubject.asObservable();
  }

  MobileOTPVerify(data: any, id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}drivers/admin/verify/${id}`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  DeleteDriver(driverData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(`${environment.base_url}${environment.base_uri}drivers/admin`, {
        headers: header,
        body: driverData,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  truckUpdate(updateTruckObj: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trucks/admin/${id}`,
        updateTruckObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetNotes(module_id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}notes/${module_id}`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  taxUpdate(updateTruckObj: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}taxes/admin/${id}`,
        updateTruckObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  DeleteTax(taxDeleteId: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(`${environment.base_url}${environment.base_uri}taxes/admin`, {
        headers: header,
        body: taxDeleteId,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetTypeTruck(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/admin/cat/type/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetLanguageID(): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}drivers/languages/known/list`
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  activityGet(token: any, search?: string): Observable<any> {
    let url = `${environment.base_url}${environment.base_uri}admin/register/requests`;
    if (search) {
      url += `?search=${search}`;
    }
    return this.httpClient
      .get(
        url,
        {
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateStatus(
    token: any,
    activeStatus: any,
    user_type: any,
    id: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/register/requests/verify/${activeStatus}/${user_type}/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateReasonStatus(
    token: any,
    activeStatus: any,
    user_type: any,
    id: any,
    reason: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/register/requests/verify/${activeStatus}/${user_type}/${id}`,
        reason,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addWeb(webPagesObj: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}webpages`,
        webPagesObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  webPagesGet(webpage_type: any): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}webpages/${webpage_type}`,
        {
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GettruckWeight(category: string): Observable<any> {
    if (!category || typeof category !== "string" || category.trim() === "") {
      return of({ status: 200, body: { data: [] } });
    }
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/cat/type/${category}`,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetAdminTrips(
    token: any,
    page: any,
    perPage: any,
    searchTripId: any,
    search_query: any,
    trip_status: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trips/admin?page=${page}&perPage=${perPage}&trip_id=${searchTripId}&search_query=${search_query}&trip_status=${trip_status}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getSuccessPayments(
    token: any,
    page: any,
    perPage: any,
    searchTripId: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trips/paymentsuccess/admin?page=${page}&perPage=${perPage}&trip_id=${searchTripId}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getFailurePayments(
    token: any,
    page: any,
    perPage: any,
    searchTripId: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trips/paymentfailure/admin?page=${page}&perPage=${perPage}&trip_id=${searchTripId}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  tripsGet(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}trips/admin`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetTruckOwner(): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/truckowner?search_query=-1`,
        {
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetDocuments(
    token: any,
    documentName: any,
    perPage: any,
    pageCount: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-documents?documentName=${documentName}&perPage=${perPage}&page=${pageCount}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  PostDocument(docData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin-documents`,
        docData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  UpdateDocument(docData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin-documents/${id}`,
        docData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  downloadELR(token: any, tripId: any, elr_id: any): Observable<any> {
    let header = new HttpHeaders({
      // Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}pdf/generate-elr/${tripId}/${elr_id}`,
        {
          headers: header,
          observe: "response",
          responseType: "blob" as "json"   // Important for PDF download
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  DeleteDocuments(docData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(`${environment.base_url}${environment.base_uri}admin-documents`, {
        headers: header,
        body: docData,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  PostGPSType(Data: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}adminGpsType`,
        Data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }

  handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else if (error.error && error.error.message) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }

  GetGpsType(
    token: any,
    serverName: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}adminGpsType?serverName=${serverName}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }

  DeleteGpsType(token: any, gps_id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}adminGpsType/${gps_id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }

  GetGps(
    token: any,
    gpsName: any,
    perPage: any,
    pageCount: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-gps?truckNo=${gpsName}&perPage=${perPage}&page=${pageCount}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  gpsAdd(Data: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(`${environment.base_url}${environment.base_uri}admin-gps`, Data, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }
  UpdateGPS(Data: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin-gps/${id}`,
        Data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }
  DeleteGps(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(`${environment.base_url}${environment.base_uri}admin-gps/${id}`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  autoGenerate(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-gps/autogenerate/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addPayment(token: any, Data: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin-truckowner-payments/${id}`,
        Data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }
  dashboard(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}admin/dashboard`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getUsersCustomer(token: any, perPage: any, page: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/userlist?perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getUsersCustomers(
    token: any,
    perPage: any,
    page: any,
    mobile: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/userlist?mobile=${mobile}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getUsersTruckOwner(
    token: any,
    perPage: any,
    truckStartPage: any,
    mobile: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/truckowner?mobile=${mobile}&perPage=${perPage}&page=${truckStartPage}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  // Admin->user->Driver (Not needed Now, using drivers/admin/list same as admin driver page)
  getUsersDriver(
    token: any,
    perPage: any,
    driverStarPpage: any,
    mobile: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/driver?mobile=${mobile}&perPage=${perPage}&page=${driverStarPpage}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getUsersAdmin(
    token: any,
    userName: any,
    perPage: any,
    driverStarPpage: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/list?userName=${userName}&perPage=${perPage}&page=${driverStarPpage}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getUsersEmployees(
    token: any,
    userName: any,
    perPage: any,
    driverStarPpage: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/s9employee/list?userName=${userName}&perPage=${perPage}&page=${driverStarPpage}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  Track(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}admin/trip/track`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  UpdateGPSType(Data: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}adminGpsType/${id}`,
        Data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }
  GetUserData(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/admin/available`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateUserType(type: any, id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/user/${type}/${id}`,

        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(this.handleError)
      );
  }
  workOrderList(
    token: any,
    status: any,
    WorkorderNo: any,
    perPage: any,
    pageCount: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-workorder?status=${status}&workOrderNo=${WorkorderNo}&perPage=${perPage}&page=${pageCount}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  ListWorkOrder(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-workorder?status=create_trip`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addAdmin(employeeData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/create`,
        employeeData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  selectedWorkOrder(_id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-workorder/trip/workorder/${_id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  vehicleList(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/admin/without-pagination`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  vehicleListEndTrip(token: any, cat: any, id?: any): Observable<any> {
    const header = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });

    // Build URL conditionally
    const url = id
      ? `${environment.base_url}${environment.base_uri}trucks/admin/without-pagination/${cat}/${id}`
      : `${environment.base_url}${environment.base_uri}trucks/admin/without-pagination/${cat}`;

    return this.httpClient.get(url, {
      headers: header,
      observe: 'response',
    });
  }

  vehicleListWithoutPagination(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/admin/without-pagination/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetVehicle(_id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-workorder/truck/details/${_id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  workOrderAddTrip(tripObj: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin-workorder/create/trip/${id}`,
        tripObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getReports(
    token: any,
    fromLocation: string,
    toLocation: string,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    tripId: any,
    download: any,
    perPage: any,
    page: any,
    report_status: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/quotes?fromLocation=${fromLocation}&toLocation=${toLocation}&fromDate=${fromDate}&toDate=${toDate}&truckCategory=${truckCategory}&tripId=${tripId}&download=${download}&perPage=${perPage}&page=${page}&report_status=${report_status}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getpaymentsReports(
    token: any,
    fromLocation: string,
    toLocation: string,
    fromDate: any,
    toDate: any,
    status: any,
    tripId: any,
    download: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/payments?fromLocation=${fromLocation}&toLocation=${toLocation}&fromDate=${fromDate}&toDate=${toDate}&status=${status}&tripId=${tripId}&download=${download}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getpaymentDetails(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/payments/receivable`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getpaymentlist(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}taxes/customer`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getpaymentlists(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}taxes-driver`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  gettodoReports(
    token: any,
    fromDate: any,
    toDate: any,
    tripStatus: any,
    tripId: any,
    bankName: any,
    truckNo: any,
    download: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/todo/report?fromDate=${fromDate}&toDate=${toDate}&tripstatus=${tripStatus}&tripId=${tripId}&bankName=${bankName}&truckNo=${truckNo}&download=${download}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  gettripsReports(
    token: any,
    fromLocation: string,
    toLocation: string,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    truckWeight: any,
    vehicleNumber: any,
    tripId: any,
    tripStatus: any,
    download: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/trips?fromLocation=${fromLocation}&toLocation=${toLocation}&fromDate=${fromDate}&toDate=${toDate}&truckCategory=${truckCategory}&truckWeight=${truckWeight}&vehicleNumber=${vehicleNumber}&tripId=${tripId}&tripStatus=${tripStatus}&download=${download}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getDriversReports(
    token: any,
    truckNo: any,
    truckOwnerName: any,
    driverStatus: any,
    download: any,
    driverName: any,
    report_status: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/drivers?truckNo=${truckNo}&truckOwnerName=${truckOwnerName}&driverStatus=${driverStatus}&download=${download}&driverName=${driverName}&driverNo=${report_status}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTransporterReports(
    token: any,
    salesOrderNo: any,
    workOrderNo: any,
    truckOwnerName: any,
    truckNo: any,
    fromDate: any,
    toDate: any,
    trip_id: any,
    download: any,

    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/truckowner/report/details?salesOrderNo=${salesOrderNo}&workOrderNo=${workOrderNo}&truckOwnerName=${truckOwnerName}&truckNo=${truckNo}&fromDate=${fromDate}&toDate=${toDate}&download=${download}&tripId=${trip_id}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getCustomerReports(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-workorder/truck/details`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getWorkOrdersReports(
    token: any,
    salesOrderNo: any,
    fromDate: any,
    toDate: any,
    workorder_no: any,
    customerName: any,
    download: any,
    perPage: any,
    page: any,
    report_status: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/workorder/report/details?salesOrderNo=${salesOrderNo}&fromDate=${fromDate}&toDate=${toDate}&workorder_no=${workorder_no}&customerName=${customerName}&download=${download}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getTrucksReports(
    token: any,
    fromLocation: string,
    toLocation: string,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    truckFeet: any,
    truckWeight: any,
    vehicleStatus: any,
    truckOwner: any,
    download: any,
    truckNumber: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/trucks?fromLocation=${fromLocation}&toLocation=${toLocation}&fromDate=${fromDate}&toDate=${toDate}&truckCategory=${truckCategory}&truckFeet=${truckFeet}&truckWeight=${truckWeight}&vehicleStatus=${vehicleStatus}&truckOwner=${truckOwner}&download=${download}&truckNumber=${truckNumber}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // Pre Orders Reports //
  getPreOrdersReports(
    token: any,
    fromLocation: string,
    toLocation: string,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    download: any,
    woid: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/preorder?fromLocation=${fromLocation}&toLocation=${toLocation}&fromDate=${fromDate}&toDate=${toDate}&truckCategory=${truckCategory}&download=${download}&woId=${woid}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getPreOrderBidRanking(token: any, workorderId: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/preorder/bidRateRanking/${workorderId}`,
        {
          headers,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getPreOrdersReports1(
    token: any,
    id: any,
    fromLocation: string,
    toLocation: string,
    userType: any,
    download: any,
    woid: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/preorder/${id}?fromLocation=${fromLocation}&toLocation=${toLocation}&userType=${userType}&download=${download}&woId=${woid}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  preorderadminList(token: any, perpage: any, page: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/workorderlist?perPage=${perpage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // ------------------ //

  getOrdersReports(
    token: any,
    fromLocation: string,
    toLocation: string,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    tripId: any,
    truckWeight: any,
    orderStatus: any,
    truckOwner: any,
    download: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/orders?fromLocation=${fromLocation}&toLocation=${toLocation}&fromDate=${fromDate}&toDate=${toDate}&truckCategory=${truckCategory}&tripId=${tripId}&truckWeight=${truckWeight}&orderStatus=${orderStatus}&truckOwner=${truckOwner}&download=${download}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getCorporateCustomerReports(
    token: any,
    id: any,
    fromDate: any,
    toDate: any,
    fromLocation: string,
    toLocation: string,
    salesOrderNo: any,
    workOrderNo: any,
    tripId: any,
    lrNo: any,
    vchlNo: any,
    download: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/customerData?id=${id}&toDate=${toDate}&fromDate=${fromDate}&fromLocation=${fromLocation}&toLocation=${toLocation}&salesOrderNo=${salesOrderNo}&workOrderNo=${workOrderNo}&tripId=${tripId}&lrNo=${lrNo}&vchlNo=${vchlNo}&download=${download}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  woorkOrderDelete(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}admin-workorder/delete/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getUsersTruckOwnerDetails(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/truckowner/details`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTruckOwnerDetails(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/truckowner/details/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addDoTruckowner(tripObj: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(`${environment.base_url}${environment.base_uri}admin-do`, tripObj, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  createWo(tripObj: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin-workorder`,
        tripObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  notifyDriver(notifyData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}push-notification/retail/trip/notify/drivers`,
        notifyData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  notifPushDriver(notifyData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}push-notification/notify/drivers`,
        notifyData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  truckOwnerUpdate(truckDataData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin/truckowner/${id}`,
        truckDataData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  createEmployee(employeeData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/s9employee`,
        employeeData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  // check 1: removed ddriver edit dialog from user page
  driverUpdate(truckDataData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin/driver/update/${id}`,
        truckDataData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  customerUpdate(truckDataData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin/customer/update/${id}`,
        truckDataData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  archiveCustomer(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}admin/customer/${id}/archive`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  SendOtp(token: any, mobile: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/sendotp`,
        mobile,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  verifyOTP(data: any, id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/verify/${data.ref_id}`,
        data
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  employeeUpdate(employeeData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin/s9employee/update/${id}`,
        employeeData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  adminUpdate(employeeData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin/update/${id}`,
        employeeData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  reportsCustomer(
    token: any,
    searchQuery: any,
    perPage: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/corporateCustomer/details?search_query=${searchQuery}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  customerdetailsReports(
    token: any,
    fromLocation: string,
    toLocation: string,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    truckFeet: any,
    truckWeight: any,
    vehicleStatus: any,
    truckOwner: any,
    download: any,
    perPage: any,
    page: any,
    report_status: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/report/trucks?fromLocation=${fromLocation}&toLocation=${toLocation}&fromDate=${fromDate}&toDate=${toDate}&truckCategory=${truckCategory}&truckFeet=${truckFeet}&truckWeight=${truckWeight}&vehicleStatus=${vehicleStatus}&truckOwner=${truckOwner}&download=${download}&perPage=${perPage}&page=${page}&report_status=${report_status}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  tripUpdate(id: any, token: any, data: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trips/update?id=${id}&unLoadedQuantity=${data}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  cancleTrip(tripsObj: any, token: any, trip_id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trips/admin/cancel/${trip_id}`,
        tripsObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  cancelQuote(trip_id: any, token: any) {
    const header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trips/admin/quote/cancel/${trip_id}`,
        {},
        {
          headers: header,
          observe: 'response',
        }
      )
      .pipe(map((response) => response));
  }

  cancelQuoteBooked(trip_id: any, token: any) {
    const header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trips/admin/quote-booked/cancel/${trip_id}`,
        {},
        {
          headers: header,
          observe: 'response',
        }
      )
      .pipe(map((response) => response));
  }

  tripCancel(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin/changeStatus/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateDo(doData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}admin-do/update`,
        doData,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getDriverRoutes(
    token?: any,
    dr_status?: any,
    search_query?: any,
    perPage?: any,
    page?: any,
    trip_status?: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}drivers/admin/driver-routes/${dr_status}?search_query=${search_query}&perPage=${perPage}&page=${page}&dr_status=${trip_status}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  createDriverRoute(token: any, data: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}driver-routes`,
        data,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAvailableTrucksForRoute(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/admin/available-for-route`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateDriverRoutes(route_id: any, token: any, data: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}drivers/admin/driver-routes/update/${route_id}`,
        data,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  settingsAdd(data: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/settings`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  settingsList(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}admin/settings`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  editWo(token: any, data: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}admin/workordertimer/${data.workorderid}?margin=${data.margin}&increase_timer=${data.increase_timer}`,
        {},
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getDriverOfflineRoutes(token: any, url: string): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}${url.startsWith("/") ? url.substring(1) : url}`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getPromotionalPushNotifications(token: any, page: number = 1, perPage: number = 10): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}promotional-push-notification?page=${page}&perPage=${perPage}`,
        { headers: header, observe: "response" }
      )
      .pipe(map((response) => response));
  }

  addPromotionalPushNotification(data: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}promotional-push-notification`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(map((response) => response));
  }

  updatePromotionalPushNotification(id: string, data: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}promotional-push-notification/${id}`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(map((response) => response));
  }

  deletePromotionalPushNotification(id: string, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}promotional-push-notification/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(map((response) => response));
  }

  triggerPromotionalPushNotification(id: string, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}promotional-push-notification/${id}/send-notification`,
        {},
        { headers: header, observe: "response" }
      )
      .pipe(map((response) => response));
  }

  generateELR(trip_id: string, token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });

    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trips/admin/elr/${trip_id}`,
        {},
        { headers, observe: 'response' }
      )
      .pipe(map((response) => response));
  }
}
